(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    function formatCountdown(milliseconds) {
      var totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      function pad(value) {
        return String(value).padStart(2, '0');
      }

      if (days > 0) return days + '日 ' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }

    function updateCountdown(countdown) {
      var endValue = countdown.dataset.countdownEnd;
      var endTime = Date.parse(endValue);

      if (!endValue || Number.isNaN(endTime)) {
        countdown.hidden = true;
        return;
      }

      var prefix = countdown.dataset.countdownPrefix || '';
      var formatted = formatCountdown(endTime - Date.now());
      countdown.hidden = false;
      countdown.textContent = prefix ? prefix + ' ' + formatted : formatted;
    }

    function setupCountdowns(root) {
      root.querySelectorAll('[data-announcement-countdown]').forEach(function (countdown) {
        updateCountdown(countdown);
      });

      if (window.announcementBarCountdownTimer) return;

      window.announcementBarCountdownTimer = window.setInterval(function () {
        document.querySelectorAll('[data-announcement-countdown]').forEach(updateCountdown);
      }, 1000);
    }

    function setupAnnouncementBars() {
      var bars = document.querySelectorAll('[data-announcement-bar]');

      bars.forEach(function (bar) {
        var storageKey = bar.getAttribute('data-announcement-bar-key');

        try {
          if (storageKey && window.sessionStorage.getItem(storageKey) === 'closed') {
            bar.hidden = true;
            return;
          }
        } catch (error) {
        }

        setupCountdowns(bar);

        var closeButton = bar.querySelector('[data-announcement-bar-close]');
        if (closeButton && closeButton.dataset.announcementBarBound !== 'true') {
          closeButton.dataset.announcementBarBound = 'true';
          closeButton.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            bar.hidden = true;

            try {
              if (storageKey) window.sessionStorage.setItem(storageKey, 'closed');
            } catch (error) {
            }
          });
        }

        var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-announcement-slide]'));
        if (slides.length <= 1 || bar.dataset.announcementCarouselBound === 'true') return;

        var activeIndex = slides.findIndex(function (slide) {
          return slide.classList.contains('is-active');
        });
        if (activeIndex < 0) activeIndex = 0;

        function showSlide(index) {
          activeIndex = (index + slides.length) % slides.length;
          slides.forEach(function (slide, slideIndex) {
            slide.classList.toggle('is-active', slideIndex === activeIndex);
          });
        }

        var intervalDuration = Number.parseInt(bar.dataset.announcementInterval, 10);
        if (!Number.isFinite(intervalDuration) || intervalDuration < 3000) intervalDuration = 5000;

        var timer;
        function start() {
          stop();
          timer = window.setInterval(function () {
            showSlide(activeIndex + 1);
          }, intervalDuration);
        }

        function stop() {
          if (!timer) return;
          window.clearInterval(timer);
          timer = undefined;
        }

        if (bar.dataset.announcementPauseOnHover === 'true') {
          bar.addEventListener('mouseenter', stop);
          bar.addEventListener('mouseleave', start);
          bar.addEventListener('focusin', stop);
          bar.addEventListener('focusout', start);
        }

        document.addEventListener('shopify:block:select', function (event) {
          var selectedSlide = event.target.closest('[data-announcement-slide]');
          if (!selectedSlide || !bar.contains(selectedSlide)) return;
          var selectedIndex = slides.indexOf(selectedSlide);
          if (selectedIndex < 0) return;
          stop();
          showSlide(selectedIndex);
        });

        document.addEventListener('shopify:block:deselect', start);

        bar.dataset.announcementCarouselBound = 'true';
        start();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAnnouncementBars);
    } else {
      setupAnnouncementBars();
    }

    document.addEventListener('shopify:section:load', setupAnnouncementBars);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  ;(function() {
    function addHiddenInput(form, name, value, className) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value || '';
      if (className) input.className = className;
      form.appendChild(input);
      return input;
    }

    function ensureRuntimeStyle() {
      if (document.getElementById('as-runtime-shop-pay-style')) return;
      var style = document.createElement('style');
      style.id = 'as-runtime-shop-pay-style';
      style.textContent = '.as-runtime-shop-pay-wrap{margin-top:.5rem;width:100%}.as-runtime-shop-pay-form{margin:0}.as-runtime-shop-pay-wrap .shopify-payment-button,.as-runtime-shop-pay-wrap .shopify-payment-button__button{width:100%}';
      document.head.appendChild(style);
    }

    function refreshPaymentButton() {
      if (!window.Shopify || !window.Shopify.PaymentButton || typeof window.Shopify.PaymentButton.init !== 'function') return;
      window.Shopify.PaymentButton.init();
    }

    function normalizeShopPayButtons() {
      var changed = false;
      var wraps = document.querySelectorAll('.as-unified-shop-pay-wrap');

      wraps.forEach(function(wrap, index) {
        if (wrap.querySelector('form.as-unified-shop-pay-form')) return;
        if (wrap.closest('form.as-unified-shop-pay-form')) return;

        var sourceForm = wrap.closest('form[action*="/cart/add"]');
        if (!sourceForm) return;

        var paymentButton = wrap.querySelector('[data-shopify="payment-button"]');
        var variantInput = sourceForm.querySelector('input[name="id"], input[name="items[0]id"]');
        var quantityInput = sourceForm.querySelector('input[name="quantity"], input[name="items[0]quantity"]');
        if (!paymentButton || !variantInput || !variantInput.value) return;

        ensureRuntimeStyle();

        var runtimeWrap = document.createElement('div');
        runtimeWrap.className = wrap.className + ' as-runtime-shop-pay-wrap';

        var runtimeForm = document.createElement('form');
        runtimeForm.method = sourceForm.method || 'post';
        runtimeForm.action = sourceForm.getAttribute('action') || '/cart/add';
        runtimeForm.acceptCharset = 'UTF-8';
        runtimeForm.enctype = 'multipart/form-data';
        runtimeForm.noValidate = true;
        runtimeForm.setAttribute('novalidate', 'novalidate');
        runtimeForm.className = 'form as-unified-shop-pay-form as-runtime-shop-pay-form';
        runtimeForm.id = (sourceForm.id || 'as-product-form-' + index) + '-shop-pay';

        addHiddenInput(runtimeForm, 'form_type', 'product');
        addHiddenInput(runtimeForm, 'utf8', '\u2713');
        addHiddenInput(runtimeForm, 'id', variantInput.value, 'as-unified-variant-id as-unified-shop-pay-variant-id');
        addHiddenInput(runtimeForm, 'quantity', quantityInput && quantityInput.value ? quantityInput.value : '1', 'as-unified-quantity as-unified-shop-pay-quantity');

        ['product-id', 'section-id'].forEach(function(name) {
          var sourceInput = sourceForm.querySelector('input[name="' + name + '"]');
          if (sourceInput) addHiddenInput(runtimeForm, name, sourceInput.value);
        });

        runtimeForm.appendChild(paymentButton);
        runtimeWrap.appendChild(runtimeForm);

        var host = sourceForm.closest('product-form') || sourceForm;
        if (!host.parentNode) return;
        host.parentNode.insertBefore(runtimeWrap, host.nextSibling);

        var oldRow = wrap.closest('.as-unified-secondary-row');
        wrap.remove();
        if (oldRow && !oldRow.querySelector('.as-unified-shop-pay-wrap, .as-unified-amazon-btn')) {
          oldRow.remove();
        }

        changed = true;
      });

      if (changed) window.setTimeout(refreshPaymentButton, 0);
    }

    normalizeShopPayButtons();
    document.addEventListener('DOMContentLoaded', normalizeShopPayButtons);
    document.addEventListener('change', function(event) {
      if (!event.target.matches('.as-product-variant, .as-form-control-number')) return;
      window.setTimeout(normalizeShopPayButtons, 0);
    });
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-main-product-v1-script')
  if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
    window.productV1 = $url.value
    var $script = document.createElement('script')
    $script.src = window.productV1
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-media-cards-script')
  if (!window.mediaCards && $url && $url.dataset.designMode !== 'yes') {
    window.mediaCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.mediaCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-quotes"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-media-quotes-script')
  if (!window.mediaCards && $url && $url.dataset.designMode !== 'yes') {
    window.mediaCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.mediaCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    console.log(555)
    console.log($url,'$url')
    console.log(window.featuredProduct, 'window.featuredProduct')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
      console.log(666);
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    console.log(555)
    console.log($url,'$url')
    console.log(window.featuredProduct, 'window.featuredProduct')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
      console.log(666);
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    console.log(555)
    console.log($url,'$url')
    console.log(window.featuredProduct, 'window.featuredProduct')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
      console.log(666);
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teasing-image-tab"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
